module.exports = __webpack_public_path__ + "static/media/playstore-badge.a848ad0a.svg";